import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { LoadingSpinner } from '@/components/loading-circle'

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
`

const GeneratingText = styled.span`
  margin-left: 8px;
`

const LoadingText = () => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <LoadingSpinner width={16} height={16} />
      <GeneratingText>
        {t('l.smart_description.generate_text.generating.text', 'Generating text...')}
      </GeneratingText>
    </Wrapper>
  )
}

export default LoadingText
